import React from "react";

const TopDistrictsChart = ({ height = "350px" }) => {
  const data = [
    { name: "Ataşehir", value: 90 },
    { name: "Bakırköy", value: 85 },
    { name: "Maltepe", value: 75 },
    { name: "Şişli", value: 70 },
    { name: "Beylikdüzü", value: 60 },
    { name: "Beşiktaş", value: 55 },
    { name: "Kartal", value: 50 },
    { name: "Fatih", value: 45 },
    { name: "Üsküdar", value: 40 },
    { name: "Sarıyer", value: 30 },
    { name: "Kadıköy", value: 25 }
  ];

  const maxValue = Math.max(...data.map(d => d.value));

  return (
    <div
      className="card p-3 shadow-sm"
      style={{
        height,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <style>
        {`
          /* Chrome, Edge, Safari */
          .card::-webkit-scrollbar {
            width: 3px; /* ince scroll */
          }
         
          /* Firefox */
          .card {
            scrollbar-width: thin;
            scrollbar-color: gray-100 transparent;
          }

        
        `}
      </style>

      <h4 style={{ fontSize: 16, marginBottom: 15 }}>
        En Çok Ziyaret Edilen İlçeler
      </h4>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px",
          padding: "0 1px",
          fontWeight: 200
        }}
      >
        <span style={{ fontSize: 14 }}>İlçe</span>
        <span>Ziyaret</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              minHeight: "30px"
            }}
          >
            <div
              style={{
                background: "rgba(137, 121, 255, 0.22)",
                borderRadius: "6px",
                width: `${(item.value / maxValue) * 80}%`,
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                color: "#000",
                fontWeight: 400,
                fontSize: "12px",
                flexShrink: 0,
                height: "100%",
                paddingLeft: 12
              }}
            >
              {item.name}
            </div>

            <div
              style={{
                color: "gray",
                fontWeight: 600,
                fontSize: "12px",
                marginLeft: "8px",
                minWidth: "30px",
                textAlign: "right"
              }}
            >
              {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopDistrictsChart;
